import axios from 'axios'
import jssdk from 'weixin-js-sdk'
import config from './config'

// 判断当前设备
// let phoneType = ''
// if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { // 判断iPhone|iPad|iPod|iOS
//   phoneType = 'iphone'
// } else if (/(Android)/i.test(navigator.userAgent)) { // 判断Android
//   phoneType = 'android'
// }
let Wechat = function (config) {
  this.isTest = config.isTest
  this.testOpenid = config.testOpenid
  this.debug = config.debug
}
Wechat.prototype.wx = jssdk

/**
 * 获取openid
 * router钩子里面调用
 */
Wechat.prototype.init = function () {
  return new Promise((resolve, reject) => {
    let that = this
    let isTest = this.isTest
    let openid = localStorage.openid
    let userId = localStorage.user_id
    let jump_number = localStorage.jump_number
    let getQueryString = function (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    }
    // alert(openid)
    if (( getQueryString('code') === null && !jump_number) || ((authExpireTime < Date.parse(new Date()) / 1000 || !authExpireTime) && !openid)) {// 没有授权 没有OPENID
      // 第一次访问
      console.log('授权登录')
      // 跳转到微信授权页面，微信授权地址通过服务端获得
      axios.post('/wechat.php/Basic/wxLogin', {
        url: encodeURIComponent(window.location.href)
      }).then(function (res) {
        res = res.data
        if (res.code === 1) {
          const data = res.data
          localStorage.authExpireTime = Date.parse(new Date()) / 1000 + 60
          if (!isTest) {
            window.location.href = data.redirect_url
          } else {
            window.location.reload()
          }
        }
      })
    } else if (!openid) { // 有授权 没有OPENID
      // 刷新页面，获取数据存储
      console.log(that.testOpenid)
      axios.post('/wechat.php/Basic/getUserinfoByCode', {
        code: getQueryString('code'),
        is_test: isTest,
        test_openid: that.testOpenid
      }).then(function (res) {
        res = res.data
        if (res.code === 1) {
          console.log(res.data)
          const data = res.data
          localStorage.jump_number = 1
          resolve(data)
        }
      })
      console.log('cookie生效期内登录')
    } else {
      // 已经登录
      console.log('已登录')
      reject(new Error('something bad happened'))
    }
  })
}

/**
 * 设置微信jssdk的配置项
 * 暂定App.vue中挂载
 */
Wechat.prototype.setConfig = function () {
  let that = this
  axios.post('/wechat.php/Basic/getJsApiSignpackage', {
    url: window.location.href
  }).then(function (res) {
    res = res.data
    if (res.code === 1) {
      const data = res.data
      console.log(data)
      that.wx.config({
        debug: that.debug,
        appId: data.signpackage.appid,
        timestamp: data.signpackage.timestamp,
        nonceStr: data.signpackage.noncestr,
        signature: data.signpackage.signature,
        jsApiList: [
          // 分享接口
          'onMenuShareWeibo',
          'updateAppMessageShareData',
          'onMenuShareAppMessage',
          'onMenuShareTimeline',
          'updateTimelineShareData',
          // 音频接口
          'startRecord',
          'stopRecord',
          'onVoiceRecordEnd',
          'playVoice',
          'pauseVoice',
          'stopVoice',
          'onVoicePlayEnd',
          'uploadVoice',
          'downloadVoice',
          // 图像接口
          'chooseImage',
          'previewImage',
          'uploadImage',
          'downloadImage',
          // 智能接口
          'translateVoice',
          // 设备信息
          'getNetworkType',
          // 地理位置
          'openLocation',
          'getLocation',
          // 界面操作
          'hideOptionMenu',
          'showOptionMenu',
          'hideMenuItems',
          'showMenuItems',
          'hideAllNonBaseMenuItem',
          'showAllNonBaseMenuItem',
          'closeWindow',
          // 微信扫一扫
          'scanQRCode',
          // 微信支付
          'chooseWXPay',
          // 微信小店
          'openProductSpecificView',
          // 微信卡券
          'addCard',
          'chooseCard',
          'openCard',
          'checkJsApi',
          'openAddress'
        ]
      })
    }
  })
}

// 关闭当前页
Wechat.prototype.closeWindow = function (obj) {
  this.wx.closeWindow();
}

/**
 * 微信扫一扫
 */
Wechat.prototype.scanQRCode = function () {
  let that = this
  return new Promise((resolve, reject) => {
    that.wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res) {
          resolve(res)
      }
    })
  })
}

Wechat.prototype.getLocation = function () {
  let that = this
  return new Promise((resolve, reject) => {
    that.wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
          console.log(res,123);
          var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          var speed = res.speed; // 速度，以米/每秒计
          var accuracy = res.accuracy; // 位置精度
      },
      complete:function(res){
          console.log(res,123);
      }
    })
  })
}

/**
 * 微信支付
 */
Wechat.prototype.wxPay = function (obj) {
  let that = this
  return new Promise((resolve, reject) => {
    that.wx.chooseWXPay({
      timestamp: obj.timeStamp,
      nonceStr: obj.nonceStr,
      package: obj.package,
      signType: obj.signType,
      paySign: obj.paySign,
      success: function (res) {
        // 支付成功后的回调函数
        resolve(res)
      },
      cancel(res){
        reject(res);
      }
    })
  })
}

/**
 * 分享给朋友
 */
Wechat.prototype.share = function (share) {
  if (share.link === '' || share.link === null || share.link === undefined) {
    share.link = location.href
  }
  return new Promise((resolve, reject) => {
    this.wx.onMenuShareAppMessage({
      title: share.title, // 分享标题
      desc: share.desc, // 分享描述
      link: share.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: share.imgUrl, // 分享图标
      success: function (res) {
        resolve(res)
      }
    })
    // this.wx.onMenuShareTimeline({
    //   title: share.title, // 分享标题
    //   link: share.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //   imgUrl: share.imgUrl, // 分享图标
    //   success: function (res) {
    //     resolve(res)
    //   }
    // })
  })
  // return new Promise((resolve, reject) => {
  //   that.wx.updateAppMessageShareData({
  //     title: share.title, // 分享标题
  //     desc: share.desc, // 分享描述
  //     link: share.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  //     imgUrl: share.imgUrl, // 分享图标
  //     success: function (res) {
  //       // 用户确认分享后执行的回调函数
  //       resolve(res)
  //     }
  //   })
  //   that.wx.updateTimelineShareData({
  //     title: share.title, // 分享标题
  //     link: share.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  //     imgUrl: share.imgUrl, // 分享图标
  //     success: function (res) {
  //       resolve(res)
  //     }
  //   })
  // })
}

/**
 * 选择图片并上传图片
 */
Wechat.prototype.chooseImage = function (obj) {
  let that = this
  return new Promise((resolve, reject) => {
    that.wx.chooseImage({
      count: obj.count, // 默认9
      sizeType: obj.sizeType || ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: obj.sourceType || ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success: function (res) {
        let localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
        that.uploadImage(localIds).then(function (res) {
          resolve(res)
        })
      }
    })
  })
}

Wechat.prototype.uploadImage = function (localIds, imgList = []) {
  let that = this
  return new Promise((resolve, reject) => {
    if (localIds.length > 0) {
      var localId = localIds.shift()
      that.wx.uploadImage({
        localId: localId,
        isShowProgressTips: 1,
        success: function (res) {
          // 上传图片有效期3天，可用微信多媒体接口下载图片到自己的服务器，此处获得的 serverId 即 media_id
          let serverId = res.serverId // 返回图片的服务器端ID
          axios.post('/wechat.php/Basic/saveFile', {
            media_id: serverId
          }).then(function (res) {
            res = res.data
            if (res.code === 1) {
              imgList.push(res.data)
            }
            that.uploadImage(localIds, imgList).then(function (res) {
              resolve(imgList)
            })
          })
        }
      })
    } else {
      resolve(imgList)
    }
  })
}

/**
 * 预览图片
 */
Wechat.prototype.previewImage = function (obj) {
  let that = this
  that.wx.previewImage({
    current: obj.url,
    urls: obj.urls
  })
}

let wx = new Wechat(config)
export default wx



// WEBPACK FOOTER //
// ./src/wx/index.js